import { useEffect, useRef, useState } from 'react';

interface Props {
    value?: number;
    maxCosts: string | number;
}

declare const numberFormatter: {
    parseNumber: (value: string | number) => number;
};

export const parseStringToNumber = (value: string | number) => {
    const parsedValue = numberFormatter.parseNumber(value);

    return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const useFinancialIndicatorsDiagramLine = ({ value, maxCosts }: Props) => {
    const [width, setWidth] = useState('0%');
    const [notShowDescription, setNotShowDescription] = useState(true);
    const diagramRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (diagramRef.current) {
            const { width, result } = getWidth(value ?? 0, maxCosts);
            setWidth(width);
            setNotShowDescription(result <= 0.17);
        }
    }, [value, maxCosts]);

    const getWidth = (value: number, maxCosts: string | number) => {
        const currentValue = parseStringToNumber(value);
        const maxValue = parseStringToNumber(maxCosts);
        if (maxValue === 0) {
            return { width: `0`, result: 0 };
        }
        const res = currentValue / maxValue;
        return { width: `${res * 100}`, result: res };
    };

    return {
        diagramRef,
        width,
        notShowDescription,
    };
};
